cv.PayDonorView = Marionette.LayoutView.extend({
  className: "view-pay-donor",

  template: cv.Templates["pay/donor/pay_donor"],

  behaviors: [
    {
      behaviorClass: cv.FormBehavior,
      suppress_notifications: true,
    },
  ],

  bindings: {},

  validation: {
    email: [
      {
        required: true,
        msg: "Required.",
      },
      {
        pattern: "email",
        msg: "Invalid e-mail",
      },
    ],
    subscribe: [],
    first_name: [
      {
        required: true,
        msg: "Required.",
      },
    ],
    last_name: [
      {
        required: true,
        msg: "Required.",
      },
    ],
    anonymous: [],
    comment: [],
    giftaid: [],
  },

  events: {
    "change #comment": "updateCountdown",
    "keydown #comment": "updateCountdown",
    "change #country": "showStates",
  },

  regions: {
    custom_fields: "#custom-fields",
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);
    this.model = cv.pay;

    // Flag for mobile payment
    this.mobile_payment = false;

    // This flag is to store cc error state because Stripe will not call after the 2nd attempt
    this.cc_error = false;

    // Bind model change to local storage but preserve team and project IDs
    this.listenTo(
      this._model_clone,
      "change",
      function (model) {
        var update_data = _.extend(model.attributes);
        update_data.project_id = cv.pay.get("project_id");
        update_data.team_id = cv.pay.get("team_id");
        update_data.last_screen = 2;
        vent.trigger("pay:save_cart", update_data);
      },
      this,
    );

    // Listeners
    this.listenTo(
      this,
      "form:saved",
      function () {
        if (this.mobile_payment == false) {
          if (cv.pay.get("submitting_payment") == false) {
            // Set submitting this payment to true
            cv.pay.set("submitting_payment", true);

            if (cv.campaign.get("payment_processor.type") == "stripe") {
              // If we have an active error, then return this and fail
              if (this.cc_error == true) {
                vent.trigger("notif:error", "Please correct your credit card information.");
                cv.pay.set("submitting_payment", false);
                return false;
              }
              this.createToken();
            }
            if (cv.campaign.get("payment_processor.type") == "paypal") {
              vent.trigger("pay:process_paypal");
            }
          }
        }
      },
      this,
    );
    this.listenTo(this, "form:changed", function (model) {}, this);
    this.listenTo(
      this,
      "form:has_errors",
      function () {
        vent.trigger("notif:error", "Please fix the errors on this form.");
      },
      this,
    );
    this.listenTo(vent, "pay:prev_button", this.previous, this);
    this.listenTo(vent, "pay:next_button", this.next, this);

    // Setup the postal stuff
    if (cv.campaign.get("enable_postal") == 1) {
      this.validation = _.extend(this.validation, {
        address: [
          {
            required: true,
            msg: "Required.",
          },
        ],
        address2: [],
        city: [
          {
            required: true,
            msg: "Required.",
          },
        ],
        state: [
          {
            required: true,
            msg: "Required.",
          },
        ],
        country: [
          {
            required: true,
            msg: "Required.",
          },
        ],
        zipcode: [],
      });
    }

    if (cv.campaign.get("payment_processor.type") == "stripe") {
      // Setup stripe stuff (Platform publishable key)
      this.stripe = Stripe(cv.PRELOADED.stripe_publishable_key, {
        stripeAccount: cv.PRELOADED.stripe_account_id,
      });

      // Set up a payment request for mobile payments if it's supported
      if (this.supportedCountry()) {
        // This is created for payment request things
        this.payment_request = this.stripe.paymentRequest({
          country: cv.PRELOADED.stripe_country,
          currency: cv.campaign.get("currency_code").toLowerCase(),
          total: {
            label: "Donation to " + cv.campaign.get("title"),
            amount: Math.round((+cv.pay.get("amount") + +cv.pay.get("tip")) * 100),
          },
          requestPayerName: true,
          requestPayerEmail: true,
        });

        // This token is only created when using mobile payments
        this.payment_request
          .on("token", function (result) {
            console.log("mobile payment token created", result);

            // Process payment and pass mobile flag
            vent.trigger("pay:process_stripe", result, true);
          })
          .on("cancel", function (result) {
            cv.pay.set("submitting_payment", false);
          });
      }
    }

    console.log("PayDonorView initialized");
  },

  templateHelpers: function () {
    return {
      is_type_campaign: cv.campaign.get("type") == "campaign" ? true : false,
      enable_subscribe: cv.campaign.get("enable_subscribe") == 1 ? true : false,
      organization_name: cv.campaign.get("organization.name"),
      enable_postal: cv.campaign.get("enable_postal") == 1 ? true : false,
      enable_giftaid: cv.campaign.get("currency_code") == "GBP" ? true : false,
      is_stripe_processor: cv.campaign.get("payment_processor.type") == "stripe" ? true : false,
    };
  },

  supportedCountry: function () {
    if (
      [
        "AT",
        "AU",
        "BE",
        "BR",
        "CA",
        "CH",
        "DE",
        "DK",
        "EE",
        "ES",
        "FI",
        "FR",
        "GB",
        "HK",
        "IE",
        "IN",
        "IT",
        "JP",
        "LT",
        "LU",
        "LV",
        "MX",
        "NL",
        "NZ",
        "NO",
        "PH",
        "PL",
        "PT",
        "RO",
        "SE",
        "SG",
        "SK",
        "US",
      ].indexOf(cv.PRELOADED.stripe_country) !== -1
    ) {
      return true;
    }
    return false;
  },

  updateCountdown: function (e) {
    // 140 is the max message length
    var remaining = 255 - this.$("#comment").val().length;
    this.$(".remaining").text(remaining);

    // Check the keycode
    var key = e.keyCode || e.charCode;
    if (key == 8 || key == 46) {
    } else {
      if (remaining == 0) {
        e.preventDefault();
        return false;
      }
    }
  },

  showStates: function () {
    // We have to use the val because it's not set yet
    if (_.isNull(this.$("#country").val())) {
      return;
    }

    // Set the zipcode validation
    if (this.$("#country").val() == "IE") {
      this.$("#zipcode").attr("placeholder", "Postcode (Optional)...");
      this.validation.zipcode = [];
    } else {
      this.$("#zipcode").attr("placeholder", "Zip/Postal Code...");
      this.validation.zipcode = [
        {
          required: true,
          msg: "Required.",
        },
      ];
    }

    // Populate the states list
    this.$("#state").html('<option value="">Loading...</option>');
    $.ajax({
      cache: false,
      type: "GET",
      url: "/pay/states/" + this.$("#country").val(),
      dataType: "json",
      success: _.bind(function (response) {
        var state_exists = false;
        this.$("#state").html('<option value="">State/Province...</option>');

        _.each(
          response.data.geonames,
          function (item, index, list) {
            if (item.name == this._model_clone.get("state")) {
              state_exists = true;
            }
            this.$("#state").append('<option value="' + item.name + '">' + item.name + "</option>");
          },
          this,
        );

        // Trigger the reset in case this loads after everything else
        if (state_exists == true) {
          this.$("#state").val(this._model_clone.get("state"));
        } else {
          this.$("#state").val("");
        }
      }, this),
      error: function (objAJAXRequest, strError) {},
    });
  },

  showCountry: function () {
    // Populate the countries list
    $.ajax({
      cache: false,
      type: "GET",
      url: "/pay/countries",
      dataType: "json",
      success: _.bind(function (data) {
        this.$("#country").html("");
        _.each(
          data,
          function (item, index, list) {
            this.$("#country").append(
              '<option value="' +
                index +
                '" data-geoid="' +
                item.split("|")[1] +
                '">' +
                item.split("|")[0] +
                "</option>",
            );
          },
          this,
        );
        this.$("#country").val(this._model_clone.get("country")).trigger("change");
      }, this),
      error: function (objAJAXRequest, strError) {},
    });
  },

  previous: function () {
    vent.trigger("pay:prev_screen");
  },

  next: function () {
    this.mobile_payment = false;
    this.trigger("form:save");
  },

  createToken: function () {
    this.stripe.createToken(this.card).then(function (result) {
      if (result.error) {
        cv.pay.set("submitting_payment", false);
        vent.trigger("notif:error", result.error.message);
      } else {
        vent.trigger("pay:process_stripe", result, false);
      }
    });
  },

  bindStripeElements: function () {
    // Build the elements
    var elements = this.stripe.elements({
      fonts: [
        {
          family: "Roboto",
          src:
            'url("https://' +
            window.location.hostname +
            '/_resources/fonts/roboto/Roboto-Regular.ttf")',
          style: "normal",
          unicodeRange:
            "U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215",
          weight: 400,
        },
        {
          family: "Roboto",
          src:
            'url("https://' +
            window.location.hostname +
            '/_resources/fonts/roboto/Roboto-Medium.ttf")',
          style: "normal",
          unicodeRange:
            "U+0000-00FF, U+0131, U+0152-0153, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2212, U+2215",
          weight: 500,
        },
      ],
    });

    // Number
    var cc_number_element = elements.create("card", {
      classes: {
        base: "form-control form-stripe-element",
        invalid: "has-error",
      },
      style: {
        base: {
          color: "#555555",
          fontFamily: "Roboto",
          "::placeholder": {
            color: "#888888",
          },
        },
      },
    });
    cc_number_element.mount(this.$("#cc_input")[0]);
    cc_number_element.on(
      "change",
      _.bind(function (event) {
        if (event.error) {
          cv.pay.set("submitting_payment", false);
          this.cc_error = true;
          this.$("#cc_input").parents(".form-group").addClass("has-error");
        } else {
          this.cc_error = false;
          this.$("#cc_input").parents(".form-group").removeClass("has-error");
        }
      }, this),
    );
    this.card = cc_number_element;
    this.listenTo(
      vent,
      "pay:clear_card",
      function () {
        this.cc_error = false;
        cv.pay.set("submitting_payment", false);
        cc_number_element.clear();
      },
      this,
    );

    // Mount the payment request button
    if (this.supportedCountry()) {
      var pr_button = elements.create("paymentRequestButton", {
        paymentRequest: this.payment_request,
      });

      // Bind the click for validation
      pr_button.on(
        "click",
        _.bind(function (e) {
          this.mobile_payment = true;
          cv.pay.set("submitting_payment", true);
          $.when(this.triggerMethod("saveForm")).then(function (result) {
            if (result === false) {
              cv.pay.set("submitting_payment", false);
              e.preventDefault();
            }
          });
        }, this),
      );

      // Check the availability of the Payment Request API first.
      this.payment_request.canMakePayment().then(
        _.bind(function (result) {
          console.log(result);
          if (result) {
            console.log("Mobile payments available...");

            pr_button.mount("#payment-request-button");
            this.$("#payment-request-wrapper").fadeIn();
            vent.trigger("pay:recalculate_iframe");
          }
        }, this),
      );
    }
  },

  bindCustomFields: function () {
    // Render the custom fields
    var customFieldsView = new cv.CustomFieldsFormView({
      custom_fields: cv.PRELOADED.custom_fields,
      values: this._model_clone.get("custom_values"),
      type: "donation",
      is_donation_form: true,
      container: this.$("#additional-info"),
    });

    // Bind a listener
    this.listenTo(
      customFieldsView,
      "form:saved",
      function (view) {
        this.trigger("form:set", "custom_values", view.getValues());
      },
      this,
    );

    // Link the custom field
    this.trigger("form:link", customFieldsView);
    this.showChildView("custom_fields", customFieldsView);
  },

  onAttach: function () {
    // Hack to prevent form submission
    document.querySelector("form").addEventListener("submit", function (e) {
      e.preventDefault();
    });

    // Bind stickit
    this.stickit(this._model_clone);

    // Bind stripe elements
    if (cv.campaign.get("payment_processor.type") == "stripe") {
      this.bindStripeElements();
    }

    // Bind the custom fields
    this.bindCustomFields();

    // Do country stuff
    if (cv.environment == "development") {
      var ip_url = "https://api.ipstack.com/check?access_key=ad7dd1aac3549ec8f8c4140ef4c21c63";
    } else {
      var ip_url = "https://api.ipstack.com/check?access_key=ad7dd1aac3549ec8f8c4140ef4c21c63";
    }

    $.ajax({
      url: ip_url,
      type: "get",
      beforeSend: function () {
        // Add this if we don't want to send the api key
      },
      success: _.bind(function (response) {
        // Try to set the default country
        if (this._model_clone.get("country") == "") {
          this._model_clone.set("country", response.country_code);
        }
        this.showCountry();
      }, this),
      error: _.bind(function () {
        // Set it as US
        if (this._model_clone.get("country") == "") {
          this._model_clone.set("country", "US");
        }
        this.showCountry();
      }, this),
    });
  },
});
